import * as Yup from "yup";
import { useFormik } from "formik";
import dynamic from "next/dynamic";
import toast, { Toaster } from "react-hot-toast";

const Turnstile = dynamic(() => import("@/components/turnstile"), {
  suspense: true,
});

export default function Form() {
  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      phone: "",
      email: "",
      business: "",
      website: "",
      message: "",
      captcha: "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      firstName: Yup.string()
        .max(15, "Must be 20 characters or less")
        .required("Required"),
      lastName: Yup.string()
        .max(20, "Must be 20 characters or less")
        .required("Required"),
      email: Yup.string().email("Invalid email address").required("Required"),
    }),
    onSubmit: async (values) => {
      const turnstile = document.getElementsByName("cf-turnstile-response");

      if (turnstile && turnstile.length > 0 && turnstile[0].value) {
        values.captcha = turnstile[0].value;
      }

      const res = await fetch("/api/email", {
        method: "POST",
        body: JSON.stringify(values),
      });

      const response = await res.json();

      if (res && !res.ok) {
        toast.error(
          response.message || "Error submitting form. Please try again later."
        );
        return;
      }

      toast.success(response.message);
      formik.resetForm();
    },
  });

  return (
    <>
      <div
        className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-c902517"
        data-id="c902517"
        data-element_type="column"
      >
        <div className="elementor-widget-wrap elementor-element-populated">
          <div
            className="elementor-element elementor-element-263aeb7 elementor-widget elementor-widget-heading"
            data-id="263aeb7"
            data-element_type="widget"
            data-widget_type="heading.default"
          >
            <div className="elementor-widget-container">
              <h2 className="elementor-heading-title elementor-size-default">
                Prefer we call you?
              </h2>
            </div>
          </div>

          <div
            className="elementor-element elementor-element-60c4fa0 elementor-widget elementor-widget-text-editor"
            data-id="60c4fa0"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              Fill out your details here and we’ll get back to you within 24
              hours.
            </div>
          </div>

          <div
            className="elementor-element elementor-element-6630d20 elementor-button-align-end elementor-mobile-button-align-center elementor-tablet-button-align-start elementor-widget elementor-widget-form"
            data-id="6630d20"
            data-element_type="widget"
            data-settings='{"step_next_label":"Next","step_previous_label":"Previous","button_width":"100","step_type":"number_text","step_icon_shape":"circle"}'
            data-widget_type="form.default"
          >
            <div className="elementor-widget-container">
              <form onSubmit={formik.handleSubmit} target="_blank">
                <div className="elementor-form-fields-wrapper elementor-labels-">
                  <div className="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-name elementor-col-50 elementor-field-required">
                    <label
                      htmlFor="form-field-name"
                      className="elementor-field-label elementor-screen-only"
                    >
                      First Name*
                    </label>
                    <input
                      type="text"
                      name="form_fields[name]"
                      id="form-field-name"
                      className="elementor-field elementor-size-sm  elementor-field-textual"
                      placeholder="First Name*"
                      required="required"
                      {...formik.getFieldProps("firstName")}
                    />
                    {formik.touched.firstName && formik.errors.firstName ? (
                      <div
                        role="alert"
                        className="elementor-message elementor-message-danger"
                      >
                        {formik.errors.firstName}
                      </div>
                    ) : null}
                  </div>

                  <div className="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-field_fcf48d1 elementor-col-50 elementor-field-required">
                    <label
                      htmlFor="form-field-field_fcf48d1"
                      className="elementor-field-label elementor-screen-only"
                    >
                      Last Name*
                    </label>
                    <input
                      type="text"
                      name="form_fields[field_fcf48d1]"
                      id="form-field-field_fcf48d1"
                      className="elementor-field elementor-size-sm  elementor-field-textual"
                      placeholder="Last Name*"
                      required="required"
                      {...formik.getFieldProps("lastName")}
                    />
                    {formik.touched.lastName && formik.errors.lastName ? (
                      <div
                        role="alert"
                        className="elementor-message elementor-message-danger"
                      >
                        {formik.errors.lastName}
                      </div>
                    ) : null}
                  </div>

                  <div className="elementor-field-type-tel elementor-field-group elementor-column elementor-field-group-field_0f15ebc elementor-col-50 elementor-md-100 elementor-field-required">
                    <label
                      htmlFor="form-field-field_0f15ebc"
                      className="elementor-field-label elementor-screen-only"
                    >
                      Phone Number*
                    </label>
                    <input
                      type="tel"
                      name="form_fields[field_0f15ebc]"
                      id="form-field-field_0f15ebc"
                      className="elementor-field elementor-size-sm  elementor-field-textual"
                      placeholder="Phone Number*"
                      required="required"
                      pattern="[0-9()#&amp;+*-=.]+"
                      title="Only numbers and phone characters (#, -, *, etc) are accepted."
                      {...formik.getFieldProps("phone")}
                    />
                    {formik.touched.phone && formik.errors.phone ? (
                      <div
                        role="alert"
                        className="elementor-message elementor-message-danger"
                      >
                        {formik.errors.phone}
                      </div>
                    ) : null}
                  </div>

                  <div className="elementor-field-type-email elementor-field-group elementor-column elementor-field-group-field_b6d7768 elementor-col-50 elementor-md-100 elementor-field-required">
                    <label
                      htmlFor="form-field-field_b6d7768"
                      className="elementor-field-label elementor-screen-only"
                    >
                      Email Address*
                    </label>
                    <input
                      type="email"
                      name="form_fields[field_b6d7768]"
                      id="form-field-field_b6d7768"
                      className="elementor-field elementor-size-sm  elementor-field-textual"
                      placeholder="Email Address*"
                      required="required"
                      {...formik.getFieldProps("email")}
                    />
                    {formik.touched.email && formik.errors.email ? (
                      <div
                        role="alert"
                        className="elementor-message elementor-message-danger"
                      >
                        {formik.errors.email}
                      </div>
                    ) : null}
                  </div>

                  <div className="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-email elementor-col-50">
                    <label
                      htmlFor="form-field-email"
                      className="elementor-field-label elementor-screen-only"
                    >
                      Business/Organization name*
                    </label>
                    <input
                      type="text"
                      name="form_fields[email]"
                      id="form-field-email"
                      className="elementor-field elementor-size-sm  elementor-field-textual"
                      placeholder="Business/Organization name*"
                      {...formik.getFieldProps("business")}
                    />
                    {formik.touched.business && formik.errors.business ? (
                      <div
                        role="alert"
                        className="elementor-message elementor-message-danger"
                      >
                        {formik.errors.business}
                      </div>
                    ) : null}
                  </div>

                  <div className="elementor-field-type-textarea elementor-field-group elementor-column elementor-field-group-message elementor-col-100">
                    <label
                      htmlFor="form-field-message"
                      className="elementor-field-label elementor-screen-only"
                    >
                      Message
                    </label>
                    <textarea
                      className="elementor-field-textual elementor-field  elementor-size-sm"
                      name="form_fields[message]"
                      id="form-field-message"
                      rows="4"
                      placeholder="Tell us how we can help"
                      {...formik.getFieldProps("message")}
                    ></textarea>
                    {formik.touched.message && formik.errors.message ? (
                      <div
                        role="alert"
                        className="elementor-message elementor-message-danger"
                      >
                        {formik.errors.message}
                      </div>
                    ) : null}
                  </div>

                  <Turnstile />

                  <div className="elementor-field-group elementor-column elementor-field-type-submit elementor-col-100 e-form__buttons">
                    <button
                      type="submit"
                      className="elementor-button elementor-size-md"
                      disabled={!formik.isValid || formik.isSubmitting}
                    >
                      <span>
                        {formik.isSubmitting ? (
                          <span className="elementor-button-text elementor-form-spinner">
                            <i className="fa fa-spinner fa-spin"></i>
                            &nbsp;
                          </span>
                        ) : (
                          <>
                            <span className="elementor-button-icon"></span>
                            <span className="elementor-button-text">
                              Submit
                            </span>
                          </>
                        )}
                      </span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          duration: 5000,
          style: {
            background: "#f9e0e2",
            color: "#e23125",
          },
          success: {
            theme: {
              primary: "green",
              secondary: "black",
            },
          },
        }}
      />
    </>
  );
}
